var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-text"},[_vm._v(" "+_vm._s(this.displayText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }